<div id="modal"
     class="modal inmodal fade"
     aria-hidden="true"
     [ngClass]="{ 'in': opened }"
     [ngStyle]="{ 'display': opened ? 'block' : ''}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body" *ngIf="bodyTemplate" [ngClass]="params.contentClass">
                <ng-container *ngTemplateOutlet="bodyTemplate; context: params.data"></ng-container>
            </div>
        </div>
    </div>
</div>
